import React, { Component } from "react";
import { GetQuery } from "Pub/js/utils";
import platform from "Pub/js/platform";
const { NCModal } = platform.base;
export default class ModalOpenApp extends Component {
    constructor(props) {
        super(props);
        this.state = { modalShow: true };
    }

    componentDidMount() {
        window.closePageModal = this.closeModalFunc;
    }

    componentWillUnmount() {
        const { container } = this.props;
        document.querySelector('.nc-workbench-container').removeChild(container);
        window.closePageModal = null;
    }

    getFieldNodeWindow = () => {
        // 这里由于嵌套了一层workbench，所以取得时候得判断
        const { container } = this.props;
        let modalIframeDoc = container.querySelector('#modal-app-iframe').contentDocument;
        const forwardIframe = modalIframeDoc.querySelector('#forwardFrame');
        if (forwardIframe) {
            modalIframeDoc = forwardIframe.contentDocument;
        }
        const mainIframe = modalIframeDoc.querySelector('#mainiframe');
        if (mainIframe) {
            return mainIframe.contentWindow;
        }
    }

    handleCancel = () => {
        return new Promise(resolve => {
            const fieldNodeWindow = this.getFieldNodeWindow();
            if (fieldNodeWindow && fieldNodeWindow.customPageClose) { // 自定义关闭
                fieldNodeWindow.customPageClose((unload = false) => { // 自定义关闭默认不执行页面卸载（按理说领域应该将页面卸载内的逻辑迁移至自定义关闭内）
                    resolve(true);
                    this.closeModalFunc(unload);
                });
            } else {
                resolve(true);
                this.closeModalFunc();
            }
        });
    }

    closeModalFunc = (needUnload = true) => {
        if (needUnload) { // 需要执行页面卸载
            const fieldNodeWindow = this.getFieldNodeWindow();
            if (fieldNodeWindow && fieldNodeWindow.onbeforeunload) {
                fieldNodeWindow.onbeforeunload();
            }
        }

        this.setState({ modalShow: false }, () => {
            const { container } = this.props;
            ReactDOM.render(null, container);
        });
    }

    render() {
        const { modalShow } = this.state;
        const { pageUrl, container } = this.props;
        const querys = GetQuery(pageUrl);
        const { modalTitle, modalSize } = querys;
        let ifr = pageUrl.replace('yonbip', 'nccloud'); // 去除yonbip那一层，内部渲染，不需要
        const sizeObj = modalSize === 'custom' ? {
            size: 'xlg',
            height: '80%',
        } : { size: modalSize || "max" };
        return <NCModal
            show={modalShow}
            { ...sizeObj }
            container={container}
            onCancel={this.handleCancel}
        >
            <NCModal.Header
                closeButton
                showMaxButton
            >
                <NCModal.Title>{modalTitle}</NCModal.Title>
            </NCModal.Header>
            <NCModal.Body>
                <iframe id="modal-app-iframe" src={ifr} width="100%" height="100%"></iframe>
            </NCModal.Body>
        </NCModal>;
    }
}
